// this file here just to silence errors about missing reducers from ws-scripts
// maybe we fix ws-scripts soon!
const root = {};

export default root;
